export default __webpack_public_path__ + "static/media/1.806431fb.png";